import { createModule } from '../../createModule';
export const createPricesAPI = createModule(({ http }) => {
    return {
        eod: {
            /**
             * Get pricing validation for a given fund over two adjacent business days.
             *
             * This should **exclude** bank holidays.
             */
            getValidation: async (params) => {
                const res = await http.get(`/v2/prices/eod/validation`, {
                    params,
                });
                return res;
            },
            /**
             * Update ops_px or comment for a pre-price validation entry.
             */
            updateValidationEntry: async (params) => {
                const res = await http.patch(`/v2/prices/eod/validation`, {
                    body: params,
                });
                return res;
            },
            /**
             * Reset a pre-price validation entry.
             */
            resetValidationEntry: async (params) => {
                const res = await http.delete(`/v2/prices/eod/validation/id/${params.entry_id}`);
                return res;
            },
            /**
             * Validate a pre-price validation entry.
             */
            validateValidationEntry: async (params) => {
                const res = await http.post(`/v2/prices/eod/validation/id/${params.entry_id}`);
                return res;
            },
            /**
             * Validate all pre-validation prices for a given date.
             */
            validateAllPrices: async (params) => {
                const res = await http.post(`/v2/prices/eod/validation/date`, {
                    body: params,
                });
                return res;
            },
            /**
             * Get the impact of price validation for a fund over two adjacent business days.
             *
             * This should **exclude** bank holidays.
             */
            getValidationImpact: async (params) => {
                const res = await http.get(`/v2/prices/eod/validation/impact`, { params });
                return res;
            },
        },
    };
});
